"use client";
import { gsap } from "gsap";
import type React from "react";
import { useEffect, useRef } from "react";
import Chat from "@/app/components/icons/Chat";
import Telegram from "@/app/components/icons/Telegram";
import Button from "@/app/components/ui/Button";

interface WorkNavigationProps {
	onBookCall?: () => void;
}

const WorkNavigation: React.FC<WorkNavigationProps> = ({ onBookCall }) => {
	const navRef = useRef<HTMLDivElement>(null);
	const bookCallButtonRef = useRef<
		HTMLButtonElement & { _originalStyles?: unknown }
	>(null);
	const telegramButtonRef = useRef<
		HTMLButtonElement & { _originalStyles?: unknown }
	>(null);

	// Animate nav bar in on mount (same as Navigation.tsx)
	useEffect(() => {
		if (navRef.current) {
			gsap.fromTo(
				navRef.current,
				{ opacity: 0, y: 48, filter: "blur(24px)" },
				{
					opacity: 1,
					y: 0,
					filter: "blur(0px)",
					duration: 0.6,
					ease: "power1.out",
				},
			);
		}
	}, []);

	return (
		<div
			ref={navRef}
			className="bottom-nav-container fixed right-0 bottom-6 left-0 z-100 m-auto flex w-fit cursor-pointer flex-col overflow-hidden rounded-full border border-gray-200 shadow-xl bg-gray-100 p-0.5 backdrop-blur-sm"
			style={{ pointerEvents: "auto" }}
		>
			<div className="flex items-center justify-center">
				<Button
					ref={bookCallButtonRef}
					variant="primary"
					icon={<Chat fill="#fff" size={20} className="min-w-[20px]" />}
					className="whitespace-nowrap"
					size="sm"
					label="Book Call"
					style={{ minWidth: 0 }}
					onClick={() => {
						if (onBookCall) onBookCall();
					}}
					aria-label="Book Call"
				/>
				<button
					type="button"
					ref={telegramButtonRef}
					className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full"
					aria-label="Join us on Telegram"
					tabIndex={0}
					style={{ minWidth: 0 }}
					onClick={() => {
						window.open(
							"https://t.me/jessevermeulen",
							"_blank",
							"noopener noreferrer",
						);
					}}
				>
					<Telegram width={22} height={22} />
				</button>
			</div>
		</div>
	);
};

export default WorkNavigation;
